import React, { useState, useEffect } from 'react';
import { apiFetch } from './utils/api';

function TextTemplatePicker({ category, onInsert }) {
  const [templates, setTemplates] = useState([]);
  const [showPicker, setShowPicker] = useState(false);
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchTemplates();
  }, [category]);

  const fetchTemplates = async () => {
    try {
      const url = category 
        ? `/api/text-templates?category=${category}`
        : '/api/text-templates';
      const res = await apiFetch(url);
      const data = await res.json();
      setTemplates(data);
    } catch (err) {
      console.error('Error fetching templates:', err);
    }
  };

  const filtered = templates.filter(t => 
    t.name.toLowerCase().includes(search.toLowerCase()) ||
    t.content.toLowerCase().includes(search.toLowerCase()) ||
    (t.shortcode && t.shortcode.toLowerCase().includes(search.toLowerCase()))
  );

  const handleInsert = (template) => {
    onInsert(template.content);
    setShowPicker(false);
    setSearch('');
  };

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onClick={() => setShowPicker(!showPicker)}
        className="px-3 py-1 text-sm bg-blue-50 text-blue-700 rounded hover:bg-blue-100 transition"
        title="Insert template text"
      >
        📝 Templates
      </button>

      {showPicker && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setShowPicker(false)}
          />
          
          {/* Picker */}
          <div className="absolute left-0 mt-2 w-96 bg-white rounded-lg shadow-xl border border-gray-200 z-50 max-h-96 overflow-hidden flex flex-col">
            {/* Search */}
            <div className="p-3 border-b border-gray-200">
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search templates..."
                className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-1 focus:ring-blue-500"
                autoFocus
              />
            </div>

            {/* Template List */}
            <div className="overflow-y-auto flex-1">
              {filtered.length === 0 ? (
                <div className="p-4 text-center text-gray-500 text-sm">
                  No templates found
                </div>
              ) : (
                filtered.map(template => (
                  <button
                    key={template.id}
                    type="button"
                    onClick={() => handleInsert(template)}
                    className="w-full text-left p-3 hover:bg-gray-50 border-b border-gray-100 transition"
                  >
                    <div className="flex items-center justify-between mb-1">
                      <span className="font-medium text-gray-900 text-sm">{template.name}</span>
                      {template.shortcode && (
                        <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded">
                          {template.shortcode}
                        </span>
                      )}
                    </div>
                    <p className="text-xs text-gray-600 line-clamp-2">{template.content}</p>
                    <span className="text-xs text-gray-400 mt-1 inline-block">{template.category}</span>
                  </button>
                ))
              )}
            </div>

            {/* Footer */}
            <div className="p-2 border-t border-gray-200 bg-gray-50 text-xs text-gray-500 text-center">
              {filtered.length} template{filtered.length !== 1 ? 's' : ''} • Manage in Settings
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default TextTemplatePicker;
